import React, { Component } from 'react';
import { Dialog, DialogHeader, DialogBody, DialogFooter } from '../../../../presentation/Dialog';

class LoadingDialog extends Component {
  onRenderHeader() {
    return (
      <DialogHeader caption='Loading Please Wait' closeButton onClose={this.props.onClose} />
    );
  }

  onRenderBody() {
    let body;

    if ( this.props.isDone ) {
      body = 'Action Completed';
    } else {
      body = this.props.body;
    }

    return (
      <DialogBody>
        <div className='file-management-loading-dialog-body'>
          {body}
        </div>
      </DialogBody>
    );
  }

  onRenderFooter() {
    return (
      <DialogFooter>
        <span className="asr-group-dialog-footer">
          <button className="asr-dialog-save-button" onClick={this.props.onClose}>Close</button>
        </span>
      </DialogFooter>
    );
  }

  render() {
    return (
      <Dialog width={20} height={20} show={this.props.show} >
        {this.onRenderHeader()}
        {this.onRenderBody()}
        {this.onRenderFooter()}
      </Dialog>
    );
  }
}

export default LoadingDialog;


// WEBPACK FOOTER //
// ./src/content/enterprise/filemanagement/components/LoadingDialog.js